export const config = {
    debugMode: false,
    // Per-tenant latest document versions. Bump a single tenant to force only that
    // tenant's users to re-accept; other tenants are unaffected. Resolve via
    // getLatestDocVersions(tenant) in utils/tenants.js.
    tenantDocVersions: {
        investceo: { termsAndConditionsVersion: '2025.1', privacyPolicyVersion: '2025.1' },
        alm: { termsAndConditionsVersion: '2025.1', privacyPolicyVersion: '2025.1' },
        smithfield: { termsAndConditionsVersion: '2026.1', privacyPolicyVersion: '2026.1' },
    },
    defaultDocVersions: { termsAndConditionsVersion: '2025.1', privacyPolicyVersion: '2025.1' },
    symbols: {
        ES: {
            pricePerPoint: 50,
        },
        MES: {
            pricePerPoint: 5,
        },
        NQ: {
            pricePerPoint: 20,
        },
        MNQ: {
            pricePerPoint: 2,
        },
        CL: {
            pricePerPoint: 1000,
        },
        MCL: {
            pricePerPoint: 100,
        },
        GC: {
            pricePerPoint: 100,
        },
        MGC: {
            pricePerPoint: 10,
        },
        ZN: {
            pricePerPoint: 1000,
        },
        MZN: {
            pricePerPoint: 100,
        },
        YM: {
            pricePerPoint: 5,
            tickValue: 1,
        },
        MYM: {
            pricePerPoint: 0.50,
            tickValue: 1,
        },
        SPX: {
            pricePerPoint: 100,
        },
    },
    supportedTickers: [
        'ES',
        'MES',
        'MNQ',
        'GC',
        'MGC',
        'MYM',
    ]
}